import { useEffect, useState } from 'react';
import { useChatApiClient } from '@trinity/chat-components/containers/Chat/useApiClient.js';

/**
 * Fetches the segmentation session ID for a given segmentation run.
 * Returns `null` while loading or if the run has no session.
 */
export function useSegmentationSessionId(segmentationRunId: number | null | undefined): string | null {
  const apiClient = useChatApiClient();
  const [sessionId, setSessionId] = useState<string | null>(null);

  useEffect(() => {
    if (!segmentationRunId) return;

    apiClient.authenticatedClient
      .get<{ run: { sessionId: string | null } }>(`/segmentation-runs/${segmentationRunId}`)
      .then((response) => {
        if (response.data.run.sessionId) {
          setSessionId(response.data.run.sessionId);
        }
      })
      .catch((error: unknown) => {
        console.error('[useSegmentationSessionId] Failed to fetch segmentation run:', error);
      });
  }, [segmentationRunId, apiClient]);

  return sessionId;
}
